// extracted by mini-css-extract-plugin
module.exports = {"listing-detail":"listing-detail_listing-detail__zCatw","section":"listing-detail_section__Uoi8s"};